import { useSbState } from 'lib/sendbird/hooks/useSbState'
import { useStore } from 'lib/store'
import { useEffect } from 'react'

// Sync app state with sb
// --
// - Must be bundled & run client-side only (dynamic import)
// - Subscribes to store observables with useEffect (basically a reaction that can access context hooks)
export const SbStateSync = () => {
  const { user } = useStore()
  const { sdk, initialized } = useSbState()

  useEffect(() => {
    if (initialized && user.profileId) {
      const upsertMetaData = !!((sdk.currentUser?.metaData as any)['userType'] as
        | string
        | undefined)
        ? 'updateMetaData'
        : 'createMetaData'

      sdk.currentUser[upsertMetaData]({
        userType: user.type
      })
      sdk
        ?.updateCurrentUserInfo({
          nickname: user.name,
          profileUrl: user.avatarUrl
        })
        .catch((err) => console.error('SbStateSync updateCurrentUserInfo error', err))
    }
  }, [initialized, sdk, user.name, user.avatarUrl, user.type, user.profileId])

  return null
}
